import { classes } from '../../../utils/class-utils';

export const unitToggleContainerStyles = classes([
  'grid',
  'grid-cols-[20px_1fr_20px]',
  'items-center',
  'ml-3',
  'gap-[10px]',
]);

export const unitLabelStyles = classes(['text-[#5D5D5D]', 'text-center', 'font-sans', 'text-sm', 'font-normal']);

export const selectedLabelStyles = classes(['text-[#272727]', 'font-medium']);
